const isAccessExpired = ({ access }) => {
  const now = Math.floor(Date.now() / 1000);
  const accessExpires = access.valid_until;

  return accessExpires - now <= 0;
};

export default isAccessExpired;
